














import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  自定义标题
 * @desc 头部添加自定义标题内容。
 */
@Component
export default class TitleExample extends Vue {
}
